import { mediaTranscriptPaths } from "@circle-react/helpers/urlHelpers";
import classnames from "classnames";
import type { CSSProperties, ComponentPropsWithRef } from "react";

export interface HtmlVideoPlayerProps extends ComponentPropsWithRef<"video"> {
  autoPlay?: boolean;
  className?: string;
  controlsList?: string;
  description?: string;
  isInset?: boolean;
  mediaTranscriptId?: string;
  poster?: string;
  preload?: "none" | "metadata" | "auto";
  rounded?: boolean;
  shouldAutoPlay?: boolean;
  src: string;
  styles?: CSSProperties;
  type: string;
}

export const HtmlVideoPlayer = ({
  src,
  type,
  poster,
  rounded = true,
  isInset = false,
  mediaTranscriptId,
  preload = "metadata",
  controlsList = "nodownload",
  description = "",
  className,
  shouldAutoPlay = false,
  styles,
  ...rest
}: HtmlVideoPlayerProps) => (
  <video
    className={classnames(className, {
      "wb-rounded-md": rounded && !isInset,
      "wb-h-full wb-w-full wb-bg-black": isInset,
    })}
    controls
    controlsList={controlsList}
    preload={preload}
    poster={poster}
    autoPlay={shouldAutoPlay}
    playsInline
    style={styles}
    {...rest}
  >
    <source src={src} type={type} />
    {description && <p className="wb-sr-only">{description}</p>}
    {mediaTranscriptId && (
      <track
        kind="captions"
        src={mediaTranscriptPaths.showVtt({ id: String(mediaTranscriptId) })}
      />
    )}
  </video>
);
